const riot = require('riot');

riot.tag2('page-projects-single', '<div class="f s-full"> <div class="box-shadow" if="{!app.useragent.isMobile}" data-is="module-sidebar"></div> <div class="f fclm s-full p32 s-p12"> <div class="s-full bg-white p32 rounded-4 box-shadow overflow-y-scroll"> <div class="mb40" ref="header" data-is="module-title-header" title="プロジェクトを{isNew ? &quot;追加&quot; : &quot;編集&quot;}" is-new="{isNew}"> <yield to="right"> <button class="button primary_fill fs12 px12 py10" if="{!app.useragent.isMobile &amp;&amp; !opts.isNew}" type="button" onclick="{parent.deleteProject}">削除</button> <button class="button primary fs12 px12 py10" if="{app.useragent.isMobile}" onclick="{parent.refs.editor.onSubmit}">作成</button> </yield> </div> <div class="container-600"> <div ref="editor" data-is="module-project-editor" project="{project}" users="{users}"></div> </div> </div> <div if="{app.useragent.isMobile}" data-is="module-tabbar"></div> </div> </div>', '', '', function(opts) {
    this.preload = async ({req, res}) => {
      this.isNew = req.params.id === 'new';

      this.users = await app.store.collection('users').fetch({ relation: true });

      if (!this.isNew) {
        var promises = [
          app.store.doc(`projects/${req.params.id}`).fetch({ relation: true }),
        ];

        var [project] = await Promise.all(promises);

        return {
          project,
        };
      }
    };

    this.on('show', () => {
      this.refs.editor.setup();
    });

    this.deleteProject = async () => {
      var result = await spat.modal.confirm('一度削除したプロジェクトは元に戻すことはできません。\n本当に削除しますか？', '削除の確認');
      if (!result) return;
      await this.project.delete();
      spat.toast.message(`${this.project.data.name}を削除しました。`);
      spat.router.push('/projects');
    };
});